<template>
  <div>
    <!-- <el-radio-group v-model="mode">
      <el-radio label="FIXEDDAYS">Jours fixes</el-radio>
    </el-radio-group> -->
    <el-select v-model="fixedDays" :placeholder="$t('common.select.placeholder')" multiple>
      <el-option
        v-for="d in days"
        :key="d"
        :label="$t('sales_orders.deliveryDay_'+d)"
        :value="d"
        :disabled="isScheduleDeliveryDayException(d)">
      </el-option>
    </el-select>
  </div>
</template>
<script>

import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'CustomerDeliveryCalendar',
	props: {
		customerDeliverySchedule : {
      type : Array,
      require : true
    }
	},
	data() {
		return {
      mode : 'FIXEDDAYS',
      days :  [1,2,3,4,5,6,7],
      fixedDays : [],
		}
	},
	computed : {
    fixedDaysSchedule(){
    },
    ...mapGetters('controlData',['isScheduleDeliveryDayException'])
   },
	methods : {
    ...mapActions('controlData',['fetchDeliveryScheduleExceptions']),
	},
	components : {

	},
	mounted(){
    this.fetchDeliveryScheduleExceptions();
    if(this.customerDeliverySchedule!=null && this.customerDeliverySchedule.length>0){
      if(this.customerDeliverySchedule[0].year==null){
        //fixedDays
        this.mode='FIXEDDAYS';
        this.fixedDays=[];
        _.forEach(this.customerDeliverySchedule, d=>{
          if(d.active){
            this.fixedDays.push(d.day);
          }
        })
      }
    }
	},
	watch : {
    fixedDays: function (val) {
      let schedule = [];
      _.forEach(this.fixedDays, d=>{
        let dayFound = _.find(this.customerDeliverySchedule, s=>{return s.day==d});
        if(dayFound!=null){
          schedule.push(dayFound)
        }else{
          schedule.push({day:d})
        }
      })
      this.$emit('change', {mode:this.mode, schedule:schedule});
    }
	}
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';



</style>
